<template>
  <div v-if="pedidoSelecionado">
    <MenuContexto>
      <template #menu-de-opcoes>
        <v-list class="font-14">
          <v-list-item @click="ativarDialogObservacao()">
            <v-icon size="19">$MessageTextLines</v-icon>
            <p class="ma-0 ml-2">Adicionar observação</p>
          </v-list-item>

          <v-list-item @click="abrirDialogListasPreco()">
            <v-icon size="19">mdi-format-list-checkbox</v-icon>
            <p class="ma-0 ml-2">Vincular lista de preços</p>
          </v-list-item>

          <AbrirCotacaoNoMenuDeContexto :pedido="pedidoSelecionado" />
        </v-list>
      </template>

      <v-snackbar v-model="alertPedidoMinimoCompra" top right light timeout="-1" shaped>
        <v-icon color="red" left>mdi-alert-outline</v-icon>
        <span>Pedido mínimo (R$ {{ Helpers.formatarValor(valorPedidoMinimoCompra) }}) para compra ainda não foi atingido!</span>
        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" @click="alertPedidoMinimoCompra = false" icon class="ml-n3">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <MensagemTopoTabela :pedido="pedidoSelecionado" />

      <div class="d-flex divider-bottom">
        <div style="width: 30%" class="py-3 pl-2">
          <h4 class="text-truncate font-15" :title="nomeFornecedor" v-text="nomeFornecedor" />
        </div>

        <div style="width: 40%" class="d-flex align-center">
          <v-tabs
            v-model="tab"
            background-color="rgba(0,0,0,.03)"
            color="primary"
            show-arrows
            centered
          >
            <v-tab
              v-for="pedido in pedidos"
              :key="pedido.idpedido"
              :href="`#tab-${pedido.idpedido}`"
              @click="mudarPedido(pedido)"
            >
              <template v-if="pedido.pedido_produtos_combinados">COMBINAÇÃO -&nbsp;</template>

              <span v-if="pedido.descricao_grupo_analise_fornecedor && ANALISE_GRUPO_FORNECEDORES">
                <template v-if="!(grupoCompra > 0)">{{ pedido.descricao_grupo.toUpperCase().replace("GRUPO", "") }} - </template>
                <template v-if="COMPRA_DISTRIBUIDA_POR_FILIAL">{{ `Filial ${pedido.filial_compra}` }} - </template>

                {{ pedido.descricao_grupo_analise_fornecedor }}
              </span>
              <span v-else-if="pedido.filial_compra > 0" v-text="`Filial ${pedido.filial_compra}`" />
              <span v-else v-text="pedido.descricao_grupo" />
            </v-tab>
          </v-tabs>

          <ConsolidaPedidosFornecedores
            v-if="ANALISE_GRUPO_FORNECEDORES"
            :pedidos="pedidos"
            @pedidos-consolidados="buscarPedidosCarrinho()" />
        </div>

        <div style="width: 30%" class="font-15">
          <div class="d-flex justify-end px-2 pt-3">
            <template v-if="pedidoSelecionado.usuario">
              <span class="font-weight-medium">Comprador: </span>
              <span v-text="pedidoSelecionado.usuario || ''" class="mr-5 pl-1 text-truncate" />
            </template>

            <span class="font-weight-medium text-truncate pr-1">Qtde. de itens: </span>
            {{ produtosPedido.length || 0 }}
          </div>
        </div>
      </div>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="pedido in pedidos"
          :key="pedido.idpedido"
          :value="`tab-${pedido.idpedido}`"
        >
          <v-card class="px-0">
            <v-card-title class="pt-0 pb-1">
              <div style="display: flex; width: 100%">
                <titulo-tabela
                  v-model="search"
                  :pedidoSelecionado="pedidoSelecionado"
                  :produtosSelecionados="produtosSelecionados"
                  @atualizarPedidos="produtosPedido = []; buscarPedidosCarrinho()"
                  @deletou="atualizarProdutosCompra"
                  @produtos-a-confirmar="confirmarEdicaoDeSugestao($event)"
                  @excluir-produtos="excluirProdutos"
                ></titulo-tabela>

                <GerenciaHeaders
                  v-if="dialog_carrinho_aberto"
                  v-model="headers"
                  class="mt-4"
                />
              </div>
            </v-card-title>

            <sys-data-table
              id="tabela-produtos-comprar"
              v-model="produtosSelecionados"
              :items="produtosPedido"
              :items-per-page="-1"
              :fixed-header="true"
              :headers="headers"
              :search="search"
              show-select
              item-key="index_row"
              :item-class="rowColor"
              no-data-text="Carregando lista de Produtos... aguarde."
              :height="ALTURA_TABELA"
              :item-height="50"
            >
              <template v-slot:item.estoque="{ item }">{{ Helpers.formatarValor(item.estoque) }}</template>

              <template v-slot:item.sugerido="{ item }">
                {{ formatar(item.sugerido) }}
              </template>
              <template v-slot:item.peso="{ item }">
                {{ formatar(getPeso(item)) }}
              </template>
              <template v-slot:item.cubagem="{ item }">
                {{ formatar(getCubagem(item)) }}
              </template>

              <template #item.classificacao_rentabilidade="{value}">
                {{ value }}
              </template>

              <template #item.classificacao_criticidade="{value}">
                <template v-if="value === 'Z'">A</template>
                <template v-else-if="value === 'Y'">B</template>
                <template v-else>C</template>
              </template>

              <template #item.descricao_produto="{ item }">
                <div class="d-flex align-center">
                  <DetalhesProduto
                    class="ml-n2"
                    :produto="{
                      id_grupo: pedido.grupo,
                      id_filial: (Number(pedido.filial_compra) === 0) ? 9999 : pedido.filial_compra,
                      id_produto: String(item.idproduto),
                      produto_eh_combinacao: pedidoSelecionado.pedido_produtos_combinados
                    }"
                  />

                  {{ item.descricao_produto }}
                </div>
              </template>

              <template #item.data_ultima_requisicao="{ item }">
                <span v-if="item.data_ultima_requisicao">
                  {{ item.data_ultima_requisicao.split('-').reverse().join('/') }}
                </span>
              </template>

              <template #item.data_ultima_entrada="{ item }">
                <span v-if="item.data_ultima_entrada">
                  {{ item.data_ultima_entrada.split('-').reverse().join('/') }}
                </span>
              </template>

              <template #header.sugestao_em_litragem>
                Sugestão em {{ CONFIG_FORNECEDOR.tipo_litragem === 'LT' ? 'litro' : 'galão' }}
              </template>

              <template #item.sugestao_em_litragem="{item}">
                <GalonagemProduto :produto="{...item, sugestao: item.qtde_pedido, tipo_litragem: CONFIG_FORNECEDOR.tipo_litragem}" />
              </template>

              <template v-slot:item.icon_motivos="{ item }">
                <v-icon
                  small
                  v-show="exibirIconMotivos(item)"
                  title="Motivos para Compra de Oportunidade"
                  @click="verificaCompraOportunidade(item)"
                >
                  mdi-information-outline
                </v-icon>
              </template>

              <template v-slot:item.qtde_pedido="{ item }">
                <div
                  v-if="!item.pedido_compra_fracionada_id"
                  class="text-cente display-flex"
                >
                  <sys-input-formatador
                    v-model="item.qtde_pedido"
                    :maxDigitos="QTDE_DECIMAIS"
                    :removerValorIrrelevante="true"
                    centralizar
                    class="input-regular w-100 font-resp txt-table-prod"
                    :style="{
                      'border-bottom-color: red' : verificaLoteEstoqueMinimo(item)
                    }"
                    @blur="validarQuantidadeCompra(item)"
                    @focus="$event.target.select()"
                    @keyup.enter="$event.target.blur();"
                    @change="item.exportado = 'N'"
                  ></sys-input-formatador>

                  <valida-lote-minimo
                    v-if="!verificaSeMultiploDeLoteMinimo(item, pedidoSelecionado) || item.qtde_pedido === 0"
                    :ref="`loteMinimo-${pedido.idpedido}-${item.idproduto}-ref`"
                    v-model.number="item.qtde_pedido"
                    :lote-minimo="parseFloat(item.lote_minimo)"
                    @change="validarQuantidadeCompra(item)"
                    @forcar-sugestao="updateCarrinhoGrupo(item)"
                  />

                  <SugestaoEstoqueEstetico
                    v-else-if="!verificaSeSurgestaoEstoqueMinimo(item, pedidoSelecionado)"
                    :ref="`estoqueEstetico-${pedido.idpedido}-${item.idproduto}-ref`"
                    v-model.number="item.qtde_pedido"
                    :estoque_minimo="item.estoque_minimo"
                    :estoque="item.estoque"
                    :estoque_transito="item.estoque_transito"
                    @change="validarQuantidadeCompra(item, false)"
                  />

                  <ValidacaoSugestaoVendaFutura
                    v-else-if="!verificarVendaFuturaValida({...item, sugestao: item.qtde_pedido, sugestao_fixa_convertivel: item.sugerido})"
                    :ref="`alerta-venda-futura-${pedido.idpedido}-${item.idproduto}-ref`"
                    :quantidade_compra="Number(item.qtde_pedido)"
                    :quantidade_sugestao="Number(item.sugerido)"
                    :quantidade_venda_futura="Number(item.estoque_pendente)"
                    @aplicar-valor="valor => {
                      item.nao_validar_venda_futura = true;
                      item.qtde_pedido = valor;
                      validarQuantidadeCompra(item);
                    }"
                  />
                </div>
                <div v-else class="text-center">
                  {{ Helpers.formatarValor(item.qtde_pedido) }}
                </div>
              </template>

              <template v-slot:item.lastro_palete="{ item }">
                {{ Helpers.formatarValor(item.lastro_palete) }}
              </template>

              <template v-slot:item.altura_palete="{ item }">
                {{ Helpers.formatarValor(item.altura_palete) }}
              </template>

              <template v-slot:item.qt_total_palete="{ item }">
                {{ Helpers.formatarValor(Number(item.lastro_palete) * Number(item.altura_palete)) }}
              </template>

              <template v-slot:item.compra_em_palete="{ item }">
                <CompraEmPalete
                  :lastro_palete="Number(item.lastro_palete)"
                  :altura_palete="Number(item.altura_palete)"
                  :quantidade_compra="Number(item.qtde_pedido)"
                  :unidade_compra="item.unidade_compra"
                />
              </template>

              <template v-slot:item.cobertura_estoque_futura="{ item }">
                <CalculaCoberturaEstoqueFutura :item="{...item, sugestao: item.qtde_pedido}" />
              </template>

              <template v-slot:item.preco_custo_base="{ item }">
                <FormatarMoeda :tipo="item.moeda" />
                {{ parseFloat(item.preco_custo_base) | numeral("0.".concat("0".repeat(QTDE_DECIMAIS))) }}
              </template>

              <template v-slot:item.preco_custo="{ item }">
                <sys-input-formatador
                  v-model="item.preco_custo"
                  :maxDigitos="QTDE_DECIMAIS"
                  :removerValorIrrelevante="true"
                  centralizar
                  class="input-regular w-100 font-resp txt-table-prod"
                  @focus="$event.target.select()"
                  @blur="validarQuantidadeCompra(item)"
                  @keyup.enter="$event.target.blur()"
                  @change="item.exportado = 'N'"
                >
                  <template #prefixo>
                    <FormatarMoeda :tipo="item.moeda" />
                  </template>
                </sys-input-formatador>
              </template>

              <template v-slot:item.indicador="{ item }">
                <div class="indicador">
                  <v-icon v-if="item.indicador > 0" color="red" small>
                    mdi-arrow-up
                  </v-icon>
                  <v-icon v-else-if="item.indicador < 0" color="green" small>
                    mdi-arrow-down
                  </v-icon>
                  <v-icon v-else class="ml-7">mdi-arrow-left-right</v-icon>
                  <v-chip v-show="item.indicador != 0" small>
                    <span style="font-size: 9pt">
                     {{ Math.abs(item.indicador) < 999 ? Helpers.formatarValor(Math.abs(item.indicador)) : "999+" }}
                    </span>
                  </v-chip>
                </div>
              </template>

              <template v-slot:item.total="{ item }">
                <FormatarMoeda :tipo="item.moeda" />
                {{ Helpers.formatarValorComCasas(totalLinha(item), 4) }}
              </template>

              <template #item.preco_liquido_total="{ item }">
                {{ Helpers.formatarValorMonetario(getPrecoLiquidoTotalItem(item)) }}
              </template>

              <template v-slot:item.action="{ item }">
                <div style="display: flex">
                  <v-spacer></v-spacer>

                  <template v-if="itemExportado(item)">
                    <v-tooltip top :open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="orange"
                          @click="() => $emit('click:exportar-alteracao-erp', {})"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-export-variant</v-icon>
                        </v-btn>
                      </template>
                      <span v-text="'Alteração não exportada para o ERP'" />
                    </v-tooltip>
                  </template>

                  <v-tooltip top open-delay="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <produto-fracionado :item="item" @fracionado="buscarProdutosDoPedidoSelecionado()" />
                      </span>
                    </template>
                    <span v-text="'Fracionar este item do pedido.'" />
                  </v-tooltip>

                  <v-btn icon @click="excluirProdutos([item])">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:footer.prepend>
                <div id="total-footer">
                  <h4 class="pl-3">
                    Total Peso (Kg):&nbsp;
                    {{Helpers.formatarValorComCasas(getTotalPeso(produtosPedido), 4) }}
                  </h4>
                  <h4 class="pl-10">
                    Total Cubagem (M³):&nbsp;
                    {{Helpers.formatarValorComCasas(getTotalCubagem(produtosPedido), 4) }}
                  </h4>
                  <h4 class="pl-10">
                    Total Preço Líquido:&nbsp;
                    {{ Helpers.formatarValorMonetario(getTotalPrecoLiquido(produtosPedido)) }}
                  </h4>
                  <h4 v-if="CONFIG_FORNECEDOR.calcular_litragem" class="pl-10">
                    Total sugestão em {{ CONFIG_FORNECEDOR.tipo_litragem === 'LT' ? 'litro' : 'galão' }}:&nbsp;
                    {{ Helpers.formatarValorComCasas(TOTAL_SUGESTAO_EM_GALAO) }}
                  </h4>

                  <h4 class="pl-10">
                    Compra em pallet:&nbsp;
                    <template v-if="Number(COMPRA_EM_PALLET_COMPUTED.qt_camandas) > 0">
                      {{ Helpers.formatarValorComCasas(COMPRA_EM_PALLET_COMPUTED.qt_camandas) }} cam.
                      |
                      <template v-if="Number(COMPRA_EM_PALLET_COMPUTED.qt_pallet) > 0">
                        {{ Helpers.formatarValorComCasas(COMPRA_EM_PALLET_COMPUTED.qt_pallet) }} pallet
                      </template>
                      <template v-else>-</template>
                    </template>
                    <template v-else>-</template>
                  </h4>
                </div>
              </template>
            </sys-data-table>

            <ObservacoesRodape :pedido="pedidoSelecionado" class="w-full" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <div id="compra-oportunidade">
        <compra-oportunidade
          :produto="produtoAEditar"
          :dialog="dialogCompraOportunidade"
          @fechar="dialogCompraOportunidade = false"
          @cancelar="cancelarEdicao"
          @salvar="updateCarrinhoGrupo(produtoAEditar, $event)"
        ></compra-oportunidade>
      </div>
      <div id="dialog-confirmar-alteracao-sugestao">
        <confirmar-alteracao-sugestao
          v-model="dialogConfirmarEdicaoSugestao"
          :produtos="prosutosAConfirmarSugestao"
          :sugestaoAtualizada="sugestaoAtualizada"
          :pedidoSelecionado="pedidoSelecionado"
          :ativarCompraOportunidade="ativarCompraOportunidade"
          @edit-item-carrinho="verificaCompraOportunidade($event)"
          @atualizar-pedido-carrinho="buscarProdutosDoPedidoSelecionado()"
        ></confirmar-alteracao-sugestao>
      </div>

      <SysDialog
        v-model="dialog_listas_preco"
        titulo="Vincular lista de preços ao pedido de compra"
        ocultarAcoes
        :largura="1200"
      >
        <TabelaCapaListas
          v-if="dialog_listas_preco"
          ativar-acoes
          :pedido_selecionado="pedidoSelecionado"
          :id_grupo="grupoCompra"
          :id_fornecedor="fornecedor.id"
          altura_tabela="calc(100vh - 330px)"
          @atualizar-carrinho="buscarPedidosCarrinho(); dialog_listas_preco = false;"
        />
      </SysDialog>

      <SysDialog
        v-model="observacao.dialog"
        titulo="Observações"
        :largura="1000"
        @click:hidden-dialog="observacao.text_fornecedor = ''; observacao.text_pedido = ''"
        @click:primary="salvarObservacao()"
      >
        <div class="d-flex pt-1">
          <v-textarea
            v-if="pedidoSelecionado.grupo_analise_fornecedor"
            v-model="observacao.text_grupo_analise"
            outlined
            name="input-7-4"
            class="mr-3"
            height="220"
            clearable
            label="Observação padrão do grupo de análise"
          ></v-textarea>
          <v-textarea
            v-else
            v-model="observacao.text_fornecedor"
            outlined
            name="input-7-4"
            class="mr-3"
            height="220"
            clearable
            label="Observação padrão do fornecedor"
          ></v-textarea>

          <v-textarea
            v-model="observacao.text_pedido"
            outlined
            name="input-7-4"
            class="ml-3"
            height="220"
            clearable
            label="Observação do pedido de compra"
          ></v-textarea>
        </div>
      </SysDialog>

      <SysDialog
        v-model="dialog_filial_compra"
        titulo="Selecione a Filial da Compra"
        @click:primary="salvarFilialCompra"
      >
        <div class="d-flex pt-1">
          <SysFilialGrupoAutocomplete
            v-model="filial_compra_selecionada"
            label="Filial"
            class="mt-1 mb-2"
            auto-select-first
            outlined
            clearable
            hide-details
          />
        </div>
      </SysDialog>
    </MenuContexto>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import compraOportunidade from "../CompraOportunidade";
import tituloTabela from "./TituloTabelaProdutosComprar";
import ProdutoFracionado from "./ProdutoFracionado";
import sysInputFormatador from "../../utils/InputFormatadorDeValor";
import GerenciaHeaders from "./GerenciaHeaders";
import ConfirmarAlteracaoSugestao from "./dialogs/ConfirmarAlteracaoSugestao";
import ValidaLoteMinimo from "../ValidaLoteMinimo";
import mixinCompra from "../MixinCompra";
import CarrinhoAPI from "./../../../api/carrinho";
import ResponsiveHeight from "./../../../helpers/ResponsiveHeight"
import ConsolidaPedidosFornecedores from "./GrupoAnalise/ConsolidaPedidosFornecedores";
import {formatarValor, formatarValorMonetario, logout} from "@/helpers";
import SugestaoEstoqueEstetico from "../SugestaoEstoqueEstetico.vue";
import MenuContexto from "../../utils/MenuContexto.vue";
import SysDialog from "../../padraoDeLayout/SysDialog.vue";
import TabelaCapaListas from "../fornecedor/ListasDePreco/TabelaCapaListas.vue";
import SysMenu from "../../utils/SysMenu.vue";
import { salvarObservacaoPedido, buscarObservacaoPedido } from "@/api/carrinho";
import MensagemTopoTabela from "@/components/compra/carrinho/MensagemTopoTabela";
import ObservacoesRodape from "@/components/compra/carrinho/ObservacoesRodape";
import AbrirCotacaoNoMenuDeContexto from "./Cotacao/AbrirCotacaoNoMenuDeContexto.vue";
import GalonagemProduto from "@/components/compra/fornecedor/GalonagemProduto/Index";
import {calcular_sugestao_em_galao} from "@/components/compra/fornecedor/GalonagemProduto/CalcularSugestaoEmGalao";
import DetalhesProduto from "@/components/produto/detalhes/Index";
import AlertaEstoqueEstetico from "@/components/compra/SugestaoEstoqueEstetico.vue";
import ValidacaoSugestaoVendaFutura from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/Index.vue";
import FormatarMoeda from "@/components/utils/FormatarMoeda.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import api from "@/api/api";
import ConfiguracoesAPI from "@/api/compras/configuracoes";
import CalculaCoberturaEstoqueFutura from "../CalculaCoberturaEstoqueFutura.vue";
import CompraEmPalete from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/CompraEmPalete.vue";

export default {
  mixins: [mixinCompra, ResponsiveHeight],
  components: {
    CompraEmPalete,
    SysFilialGrupoAutocomplete,
    FormatarMoeda,
    ValidacaoSugestaoVendaFutura,
    AlertaEstoqueEstetico,
    GalonagemProduto,
    ObservacoesRodape,
    MensagemTopoTabela,
    ConsolidaPedidosFornecedores,
    GerenciaHeaders,
    compraOportunidade,
    tituloTabela,
    ProdutoFracionado,
    sysInputFormatador,
    ConfirmarAlteracaoSugestao,
    ValidaLoteMinimo,
    SugestaoEstoqueEstetico,
    MenuContexto,
    SysDialog,
    TabelaCapaListas,
    SysMenu,
    AbrirCotacaoNoMenuDeContexto,
    DetalhesProduto,
    CalculaCoberturaEstoqueFutura
  },
  props: [
    "pedidosProp",
    "buscarProdutos",
    "atualizarPedidos",
    "ativarCompraOportunidade",
    "valorPedidoMinimoCompra",
    "dialog_carrinho_aberto",
  ],
  data: () => ({
    tab: null,
    ativarAtualizacaoDetalhesProduto: false,
    ativaCompraOportunidade: false,
    dialogCompraOportunidade: false,
    search: "",
    produtosPedido: [],
    pedidoSelecionado: {},
    produtoAEditar: {},
    pedidos: [],
    produtosSelecionados: [],
    headers: [],
    interval: "",
    dialogConfirmarEdicaoSugestao: false,
    prosutosAConfirmarSugestao: [],
    sugestaoAtualizada: {},
    alertPedidoMinimoCompra: false,
    dialog_observacao: false,
    dialog_listas_preco: false,
    observacao: {
      dialog: false,
      text_fornecedor: '',
      text_pedido: '',
      text_grupo_analise: ''
    },
    dialog_filial_compra: false,
    filial_compra_selecionada: 0,
    configuracoes_compras: {}
  }),
  created() {
    this.buscarPedidosCarrinho();
    this.buscarConfiguracoesCompras();
  },
  computed: {
    ...mapGetters({
      fornecedor: "fornecedor/getFornecedor",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      configuracoes: "configuracoes/carrinho",
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
      COMPRA_DISTRIBUIDA_POR_FILIAL: "CompraDistribuidaPorFilial/get_distribuir_por_filial",
      GET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO: "CotacaoCarrinhoCompra/GET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO",
      GET_ATUALIZAR_CARRINHO_COMPRAS: "CotacaoCarrinhoCompra/GET_ATUALIZAR_CARRINHO_COMPRAS",
      CONFIG_FORNECEDOR: "fornecedor/getConfig",
    }),
    nomeFornecedor() {
      return this.fornecedor.id + " - ".concat(this.fornecedor.razao_social);
    },
    QTDE_DECIMAIS() {
      return this.configuracoes.CASAS_DECIMAIS_CARRINHO;
    },
    resultPedidoMinimo() {
      return this.pedidoSelecionado.total;
    },
    produtoInvalidoParaExportacao() {
      if (!this.produtosPedido) {
        return false;
      }

      if (!this.pedidoSelecionado.grupo) {
        return false;
      }

      const FILTRA_ITENS_INVALIDOS = (item) =>
        !item.qtde_pedido ||
        !item.preco_custo ||
        item.qtde_pedido <= 0 ||
        item.preco_custo <= 0;

      const itemsPedido = this.produtosPedido.filter(FILTRA_ITENS_INVALIDOS);

      return itemsPedido.length > 0;
    },
    ANALISE_GRUPO_FORNECEDORES() {
      return localStorage.analiseGrupoFornecedores === 'S'
    },
    ALTURA_TABELA () {
      const {id_capa_lista, observacao_fornecedor, observacao_pedido, observacao_grupo_analise} = this.pedidoSelecionado;
      let altura = this.alturaDaJanela - 211;

      if (id_capa_lista) {
        altura -= 29;
      }

      if (observacao_fornecedor || observacao_pedido || observacao_grupo_analise) {
        altura -= 30;
      }

      return altura;
    },
    TOTAL_SUGESTAO_EM_GALAO() {
      const callback = (a, b) => {
        const produto = {...b, sugestao: b.qtde_pedido, tipo_litragem: this.CONFIG_FORNECEDOR.tipo_litragem};
        return calcular_sugestao_em_galao(produto) + a;
      };
      return this.produtosPedido.reduce(callback, 0);
    },
    COMPRA_EM_PALLET_COMPUTED() {
      return {
        qt_camandas: this.produtosPedido.reduce((a, b) => {
          if (!Number(b.lastro_palete)) {
            return a;
          }

          return a + Number(b.qtde_pedido / Number(b.lastro_palete));
        }, 0),
        qt_pallet: this.produtosPedido.reduce((a, b) => {
          if (!Number(b.lastro_palete) || !Number(b.altura_palete)) {
            return a;
          }

          return a + Number(b.qtde_pedido / (Number(b.lastro_palete) * Number(b.altura_palete)));
        }, 0)
      };
    }
  },
  watch: {
    GET_ATUALIZAR_CARRINHO_COMPRAS() {
      this.buscarProdutosDoPedidoSelecionado();
    },
    GET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO() {
      this.produtosSelecionados = [];
    },
    produtosSelecionados(valor) {
      this.setProdutosSelecionadosCarrinho(valor);
    },
    resultPedidoMinimo() {
      this.validaPedidoMinimo();
    },
    pedidoProp() {
      this.pedidos = this.pedidosProp.map(item => ({...item}));
    },
    buscarProdutos() {
      if (this.buscarProdutos) {
        this.buscarPedidosCarrinho()
      }
    },
    pedidoSelecionado(novoPedido) {
      this.$emit("pedidoSelecionado", novoPedido);
      this.validaPedidoMinimo();
      this.produtosPedido = [];
      this.produtosSelecionados = [];

      if (novoPedido && novoPedido.idpedido) {
        this.tab = `tab-${novoPedido.idpedido}`
        this.buscarProdutosDoPedidoSelecionado()
      }
    },
    atualizarPedidos() {
      if (this.atualizarPedidos > 0) {
        this.buscarPedidosCarrinho();
      }
    },
    valorPedidoMinimoCompra() {
      this.validaPedidoMinimo();
    },
    produtoInvalidoParaExportacao(novoValor) {
      this.$emit("produto-invalido-para-exportacao", novoValor);
    },
    pedidos(novos_pedidos) {
      if (novos_pedidos.length === 0) {
        this.pedidoSelecionado = {};
        return;
      }

      const pedido_selecionado_atualizado = novos_pedidos
        .find(item => this.pedidoSelecionado.idpedido === item.idpedido);

      if (pedido_selecionado_atualizado) {
        this.mudarPedido(pedido_selecionado_atualizado);
      } else {
        this.mudarPedido(this.pedidos[0] || {});
      }
    },
    produtosPedido: {
      handler(produtos) {
        produtos = produtos.map(item => {
          item.indicador = this.custoVsBase(item);
          return item;
        });
        this.$emit("produtos-pedido", produtos)
      },
      deep: true
    },
  },
  methods: {
    formatarValor,
    ...mapMutations({
      setProdutosSelecionadosCarrinho: "CotacaoCarrinhoCompra/SET_PRODUTOS_SELECIONADOS_CARRINHO"
    }),
    ativarDialogObservacao() {
      const parametros = { idpedido: this.pedidoSelecionado.idpedido };
      this.$store.dispatch(
        "loading/addRequisicao",
        buscarObservacaoPedido(parametros)
          .then((dados) => {
            this.observacao.text_fornecedor = dados.observacao_fornecedor;
            this.observacao.text_pedido = dados.observacao_pedido;
            this.observacao.text_grupo_analise = dados.observacao_grupo_analise;
            this.observacao.dialog = true;
          })
      );
    },
    salvarObservacao() {
      const parametros = {
        idpedido: this.pedidoSelecionado.idpedido,
        observacao_fornecedor: this.observacao.text_fornecedor,
        observacao_pedido: this.observacao.text_pedido,
        observacao_grupo_analise: this.observacao.text_grupo_analise
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        salvarObservacaoPedido(parametros)
          .then(() => {
            this.observacao.text_fornecedor = '';
            this.observacao.text_pedido = '';
            this.observacao.text_grupo_analise = '';
            this.observacao.dialog = false;
            this.buscarPedidosCarrinho();
          })
      );
    },
    abrirDialogListasPreco() {
      this.dialog_listas_preco = true;
    },
    validarQuantidadeCompra(produto, validar_estoque_minimo = true) {
      this.$nextTick(() => {
        if (!this.verificaSeMultiploDeLoteMinimo(produto) || produto.qtde_pedido === 0) {
          this.ativarAlertaLoteMinimoProduto(produto);
          produto.nao_validar_venda_futura = false;
          return;
        }

        if (validar_estoque_minimo && !this.verificaSeSurgestaoEstoqueMinimo(produto, this.pedidoSelecionado)) {
          this.ativarAlertaEstoqueEsteticoProduto(produto);
          produto.nao_validar_venda_futura = false;
          return;
        }

        if (produto.nao_validar_venda_futura === false && this.verificarVendaFuturaValida({ ...produto, sugestao: produto.qtde_pedido, sugestao_fixa: produto.sugerido }) === false) {
          this.ativarAlertaVendaFutura(produto);
          return;
        }

        this.verificaCompraOportunidade(produto);
      })
    },
    ativarAlertaLoteMinimoProduto(produto) {
      const loteMinimoRef = `loteMinimo-${this.pedidoSelecionado.idpedido}-${produto.idproduto}-ref`;

      if (this.$refs[loteMinimoRef] && this.$refs[loteMinimoRef].length > 0) {
        this.$refs[loteMinimoRef][0].ativador_menu = true;
      }
    },
    ativarAlertaEstoqueEsteticoProduto(produto) {
      const estoqueExteticoRef = `estoqueEstetico-${this.pedidoSelecionado.idpedido}-${produto.idproduto}-ref`;

      setTimeout(() => {
        if (this.$refs[estoqueExteticoRef] && this.$refs[estoqueExteticoRef].length > 0) {
          this.$refs[estoqueExteticoRef][0].ativador_menu = true;
        }
      }, 300)
    },
    ativarAlertaVendaFutura(produto) {
      const vendaFuturaRef = `alerta-venda-futura-${this.pedidoSelecionado.idpedido}-${produto.idproduto}-ref`;

      setTimeout(() => {
        if (this.$refs[vendaFuturaRef] && this.$refs[vendaFuturaRef].length > 0) {
          this.$refs[vendaFuturaRef][0].menu_ativo = true;
        }
      }, 300);
    },
    verificaLoteEstoqueMinimo (item) {
      return !this.verificaSeMultiploDeLoteMinimo(item) && !this.verificaSeSurgestaoEstoqueMinimo(item, this.pedidoSelecionado);
    },
    buscarConfiguracoesCompras() {
      const headers = this.Helpers.iniciarRequisicao();

      ConfiguracoesAPI.getConfiguracoesCompras(headers)
      .then((response) => {
        const { token, configs } = response.data;
        localStorage.setItem("token", token);

        this.configuracoes_compras = configs;
      })
      .catch(() => { this.Helpers.logout(); })
    },
    buscarPedidosCarrinho () {
      const headers = this.Helpers.iniciarRequisicao()
      const params = {
        grupo: this.grupoCompra,
        filial: this.filialCompra,
        fornecedor: this.fornecedor.id,
        embalagemMaster: this.embalagemMasterAtivada ? 'S' : 'N',
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
        compra_por_filial: (this.COMPRA_DISTRIBUIDA_POR_FILIAL && parseInt(this.filialCompra) === 0) ? 'S' : 'N'
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.getPedidosCompraCarrinho(headers, params)
          .then(resp => {
            const {token, pedidos} = resp.data;
            localStorage.token = token;
            this.pedidos = pedidos;

            this.abrirDialogFilialCompra(pedidos);
          })
          .catch(() => this.Helpers.logout())
      );
    },
    abrirDialogFilialCompra(pedidos) {
      for (let i = 0; i < this.pedidos.length; i += 1) {
        if (
          pedidos[i].filial_compra === 0 &&
          pedidos[i].filial_pedido_exportado === null &&
          this.configuracoes_compras.EXPORTACAO_PEDIDO_COMPRA_GRAVIA
        ) {
          this.dialog_filial_compra = true;
          break;
        }
      }
    },
    buscarProdutosDoPedidoSelecionado () {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        filial_compra: this.filialCompra,
        id_pedido: this.pedidoSelecionado.idpedido,
        pedido_produtos_combinados: this.pedidoSelecionado.pedido_produtos_combinados ? 'S' : 'N',
        id_fornecedor: this.fornecedor.id
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.getProdutosDoPedidoSelecionado(headers, params).then(resp => {
          const { token, produtos } = resp.data;
          localStorage.token = token;

          this.produtosPedido = produtos.sort((a, b) => {
            if (a.item !== b.item) return a.item - b.item;
            return 0;
          });

          this.produtosPedido.map(item => {
            if (item.data_ultima_requisicao) {
              item.data_ultima_requisicao = item.data_ultima_requisicao.split('/').reverse().join('-');
            }
            if (item.data_ultima_entrada) {
              item.data_ultima_entrada = item.data_ultima_entrada.split('/').reverse().join('-');
            }
            return item;
          });
        }).catch(() => this.Helpers.logout())
      )
    },
    validaPedidoMinimo() {
      this.alertPedidoMinimoCompra =
        Number(this.valorPedidoMinimoCompra) >
        Number(this.pedidoSelecionado.total) &&
        Number(this.valorPedidoMinimoCompra) > 0;
    },
    confirmarEdicaoDeSugestao(itens) {
      this.dialogConfirmarEdicaoSugestao = true;
      this.prosutosAConfirmarSugestao = itens;
    },
    itemExportado(item) {
      const { exportado } = item;
      const { pedido_cli } = this.pedidoSelecionado;

      return exportado === "N" && parseInt(pedido_cli) !== 0;
    },
    formatar(valor) {
      return this.Helpers.formatarValor(valor);
    },

    getTotalCubagem(data) {
      return data.reduce((a, b) => parseFloat(a) + this.getCubagem(b), 0);
    },

    getTotalPeso(data) {
      return data.reduce((a, b) => parseFloat(a) + this.getPeso(b), 0);
    },

    getPrecoLiquidoTotalItem(item) {
      return Number(item.valor_liquido || 0) * Number(this.getQtdePedido(item) || 0);
    },

    getTotalPrecoLiquido(data) {
      return data.reduce((a, b) => parseFloat(a) + parseFloat(Number(b.valor_liquido) * Number(b.qtde_pedido_na_embalagem_minima)), 0);
    },

    converterValorParaEmbalagemMinima(valor, tipo_fator, multiplo_compra) {
      if (tipo_fator === 'D') {
        return Number((valor * multiplo_compra) || 0);
      }

      return Number((valor / multiplo_compra) || 0);
    },

    getCubagem: function (item) {
      const {altura, largura, comprimento} = item;

      const qtde = this.pedidoSelecionado.emb_master === 'S'
        ? this.converterValorParaEmbalagemMinima(item.qtde_pedido || 0, item.tipo_fator_conversao, item.multiplo_compra)
        : item.qtde_pedido;

      const a = altura * largura * comprimento;
      const b = parseFloat(qtde);

      return a * b > 0 ? a * b : 0;
    },

    getPeso: function (item) {
      const qtde = this.pedidoSelecionado.emb_master === 'S'
        ? this.converterValorParaEmbalagemMinima(item.qtde_pedido || 0, item.tipo_fator_conversao, item.multiplo_compra)
        : item.qtde_pedido;

      const resultado = item.peso * parseFloat(qtde);
      return resultado > 0 ? resultado : 0;
    },
    // deletar(produto) {
    //   this.$store.dispatch(
    //     "loading/addRequisicao",
    //     this.$store
    //       .dispatch("carrinho/Delete", {
    //         pedido: this.pedidoSelecionado.idpedido,
    //         produto: produto.idproduto,
    //         fornecedor: produto.idfornecedor,
    //         grupo: produto.grupo,
    //       })
    //       .then(response => {
    //         if (this.produtosPedido.length > 1) {
    //           this.buscarProdutosDoPedidoSelecionado()
    //         } else {
    //           this.buscarPedidosCarrinho();
    //         }
    //
    //         this.verificarResultadosApiExportacao(response);
    //         this.$emit("atualizarProdutosCompra");
    //       })
    //   );
    // },
    cancelarEdicao() {
      this.buscarProdutosDoPedidoSelecionado();
      this.dialogCompraOportunidade = false;
    },
    exibirIconMotivos(item) {
      const qtde = parseFloat(item.qtde_pedido);
      const sugerido = parseFloat(item.sugerido);

      return qtde > sugerido && this.ativarCompraOportunidade === "S";
    },
    totalLinha(item) {
      const { preco_custo, qtde_pedido } = item;
      const RESULTADO = parseFloat(preco_custo) * parseFloat(qtde_pedido);

      return RESULTADO > 0 ? RESULTADO : 0;
    },
    qtdePedidoError(produto) {
      const QTDE = parseFloat(produto.qtde_pedido);

      if (QTDE >= 0.0001) {
        return false;
      } else {
        alert("A quantidade mínimo de produto é 0,0001");
        return true;
      }
    },
    precoCustoError(produto) {
      const { CASAS_DECIMAIS_CARRINHO: DECIMAIS } = this.configuracoes;

      const PRECO = parseFloat(produto.preco_custo);

      const STR_MIN = 0; //"0.".concat("0".repeat(DECIMAIS - 1)).concat("1");
      const MIN = parseFloat(STR_MIN);

      if (PRECO >= MIN) {
        return false;
      } else {
        alert(`O Preço mínimo de Custo é ${MIN}`);
        return true;
      }
    },
    totalError(produto) {
      const QTDE = parseFloat(produto.qtde_pedido);
      const PRECO = parseFloat(produto.preco_custo);

      if ((QTDE * PRECO) > 99999999.9999) {
        if (!produto.alerta_total_exibido) {
          alert("A quantidade informada, combinada com o preço unitário, resulta em um valor total superior ao limite permitido.");
          produto.alerta_total_exibido = true;
        }
        return true;
      }

      produto.alerta_total_exibido = false;
      return false;
    },
    converterEmbalagemValorProduto(produto, valor) {
      if (this.pedidoSelecionado.emb_master === "N") {
        return parseFloat(valor);
      }

      if (produto.tipo_fator_conversao === 'D') {
        return parseFloat(valor) / parseFloat(produto.multiplo_compra);
      }

      return parseFloat(valor) * parseFloat(produto.multiplo_compra);
    },
    getQtdePedido(p) {
      if (this.pedidoSelecionado.emb_master === "N") {
        return parseFloat(p.qtde_pedido);
      }

      if (p.tipo_fator_conversao === 'D') {
        return parseFloat(p.qtde_pedido) * parseFloat(p.multiplo_compra);
      }

      return parseFloat(p.qtde_pedido) / parseFloat(p.multiplo_compra);
    },
    getSugerido(p) {
      if (this.pedidoSelecionado.emb_master === "N") {
        return parseFloat(p.sugerido);
      }

      if (p.tipo_fator_conversao === 'D') {
        return parseFloat(p.sugerido) * parseFloat(p.multiplo_compra);
      }

      return parseFloat(p.sugerido) / parseFloat(p.multiplo_compra);
    },
    getPrecoCusto(p) {
      if (this.pedidoSelecionado.emb_master === "N") {
        return parseFloat(p.preco_custo);
      }

      if (p.tipo_fator_conversao === 'D') {
        return parseFloat(p.preco_custo) / parseFloat(p.multiplo_compra);
      }

      return parseFloat(p.preco_custo) * parseFloat(p.multiplo_compra);
    },
    updateCarrinhoGrupo(produto, motivos = []) {
      const ERROR = {
        qtde: this.qtdePedidoError(produto),
        preco: this.precoCustoError(produto),
        total: this.totalError(produto),
      };

      if (!ERROR.qtde && !ERROR.preco && !ERROR.total) {
        this.sugestaoAtualizada = null;

        const qtde = produto.igualar_qtde_sugestao
          ? produto.nova_sugestao
          : this.getQtdePedido(produto);

        const nova_sugestao = this.dialogConfirmarEdicaoSugestao
          ? produto.nova_sugestao
          : undefined;

        this.$store.dispatch(
          "loading/addRequisicao",
          this.$store
            .dispatch("carrinho/Store", {
              fornecedor: produto.idfornecedor,
              produto: produto.idproduto,
              grupo: produto.grupo,
              filial: produto.filial_compra,
              qtde,
              preco_custo: this.getPrecoCusto(produto),
              sugestao: this.getSugerido(produto),
              motivos: motivos,
              nova_sugestao,
              analiseGrupoFornecedores: this.pedidoSelecionado.grupo_analise_fornecedor ? 'S' : 'N',
              pedido_produtos_combinados: this.pedidoSelecionado.pedido_produtos_combinados ? 'S' : 'N',
              produto_eh_combinacao: this.pedidoSelecionado.pedido_produtos_combinados,
            })
            .then((response) => {
              const {total_custo, total_custo_base} = response.totais

              this.pedidoSelecionado.total = total_custo
              this.pedidoSelecionado.total_pelo_custo_base = total_custo_base

              const FILTRA_PRODUTO = (item) => item.idproduto === produto.idproduto;

              const PRODUTO_DESATUALIZADO = this.produtosPedido.filter(FILTRA_PRODUTO)[0] || null;
              let produto_editado = response.produtos.filter(FILTRA_PRODUTO)[0] || null;

              if (PRODUTO_DESATUALIZADO && produto_editado) {
                const INDEX_PRODUTO = this.produtosPedido.indexOf(PRODUTO_DESATUALIZADO);
                produto_editado.qtde_pedido = parseFloat(produto_editado.qtde_pedido);
                produto_editado.preco_custo = parseFloat(produto_editado.preco_custo);
                this.produtosPedido.splice(INDEX_PRODUTO, 1, produto_editado);
              }

              this.sugestaoAtualizada = produto;
              this.validaPedidoMinimo();
            })
            .catch((erro) => {
              this.Helpers.logout();
              this.sugestaoAtualizada = { erro };
            })
        );
      } else {
        this.buscarProdutosDoPedidoSelecionado();
      }
    },
    verificaCompraOportunidade(produto) {
      clearTimeout(this.interval);

      this.interval = setTimeout(() => {
        if (this.ativarCompraOportunidade === "S") {
          const QTDE = parseFloat(produto.qtde_pedido);
          const SUGERIDO = parseFloat(produto.sugerido);

          if (QTDE > SUGERIDO) {
            this.produtoAEditar = produto;
            this.dialogCompraOportunidade = !this.dialogCompraOportunidade;
          } else {
            this.updateCarrinhoGrupo(produto);
          }
        } else {
          this.updateCarrinhoGrupo(produto);
        }
      }, 600);
    },
    custoVsBase(i) {
      const custo = parseFloat(i.preco_custo);
      const custoBase = parseFloat(i.preco_custo_base);

      const precoCustoValido = custo > 0 ? custo : 0;

      let percentual;

      if (i.preco_custo_base > 0) {
        percentual = ((precoCustoValido / custoBase - 1) * 100).toFixed(2);
      } else {
        percentual = 0;
      }

      return percentual;
    },
    rowColor(item) {
      const { qtde_pedido, sugerido, pedido_compra_fracionada_id } = item;
      if (
        !pedido_compra_fracionada_id &&
        parseFloat(qtde_pedido) !== parseFloat(sugerido)
      ) {
        return "row-color";
      } else {
        return "";
      }
    },
    mudarPedido(pedido) {
      // pedido.idfornecedor = this.fornecedor.id; "Removido por motivos de já vim do back"
      this.pedidoSelecionado = pedido;
    },
    atualizarProdutosCompra() {
      this.buscarPedidosCarrinho();
      this.$emit("atualizarProdutosCompra");
    },
    async excluirProdutos(produtos) {
      const parametros = {
        pedido: this.pedidoSelecionado.idpedido,
        produtos: []
      };

      produtos.forEach(produto => {
        const produto_delecao = {
          idpedido: produto.idpedido,
          idproduto: produto.idproduto,
          idfornecedor: produto.idfornecedor,
          grupo: produto.grupo,
        };

        parametros.produtos.push(produto_delecao);
      })

      await this.$store.dispatch("loadingAux/habilitarLoading", true);

      await CarrinhoAPI.excluirProdutos(parametros)
        .then(resposta => {
          localStorage.token = resposta.data.token;

          if (this.produtosPedido.length > 1) {
            this.buscarProdutosDoPedidoSelecionado()
          } else {
            this.buscarPedidosCarrinho();
          }

          this.atualizarProdutosCompra();
          this.verificarResultadosApiExportacao(resposta);
          this.$emit("atualizarProdutosCompra");
        })
        .catch(() => logout());

      await this.$store.dispatch("loadingAux/habilitarLoading", false);
    },
    verificarResultadosApiExportacao(response) {
      const {resultado_exclusao_api_exportacao} = response.data;

      if (resultado_exclusao_api_exportacao.sankhya) {
        const ev = {
          ...resultado_exclusao_api_exportacao.sankhya,
          callbackFn: this.excluirProdutos
        }
        this.$emit("sankhya:resultado-exclusao-produto", ev)
      }
    },
    salvarFilialCompra() {
      const body = {
        idpedido: this.pedidoSelecionado.idpedido,
        filial_pedido_exportado: this.filial_compra_selecionada
      };

      api.put('carrinho/alterar-filial-exportada', body).then(() => {
        this.dialog_filial_compra = false;
      }).catch(logout);
    },
    formatarDinheiro: formatarValorMonetario,
  },
};
</script>

<style scoped>
.h4 {
  color: #222;
  font-size: 16px;
}
.mln-6 {
  margin-left: -6px;
}
.indicador {
  display: flex;
  font-size: 10px;
  margin-right: 5px;
}
#total-footer {
  display: flex;
  color: #555;
}
</style>

<style>
#tabela-produtos-comprar .v-data-table__wrapper {
  height: calc(100vh - 228px) !important;
  overflow-y: auto !important;
}
#tabela-produtos-comprar .v-data-table__wrapper table tbody tr td,
#tabela-produtos-comprar .v-data-table__wrapper table thead tr th {
  font-size: 9pt;
  padding-left: 6px !important;
  padding-top: 5px;
  padding-right: 6px;
  /* text-align: center; */
}

.tab-centered {
  position: absolute;
  text-align: center;
  align-items: center;
}
.divider-bottom {
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.txt-table-prod {
  padding: 0;
  /* max-width: 100px;
  min-width: 100px; */
  margin: 0;
  margin-top: 2px;
}
.txt-table-prod .v-input__control .v-input__slot * {
  text-align: center;
  margin: 0;
  padding: 0;
  padding-left: 3px;
}
.row-color {
  color: #ff0000;
}
.row-color .v-input__control .v-input__slot * {
  color: #ff0000;
}
#remover {
  margin: auto;
  display: flex;
  width: 280px;
}
#converter {
  width: 200px;
  margin: auto;
}
#tabela-produtos-comprar .v-data-table__wrapper table thead tr th {
  vertical-align: top !important;
  padding-top: 10px !important;
  padding-bottom: 0 !important;
  font-size: 11.5px !important;
}
.display-flex {
  display: flex;
}
</style>
